<template>
    <div>
        <div class="row stepper-row">
            <Step
                    v-for="step in items"
                    :key="step.text"
                    :step="step"
                    @stepClicked="handleStepClicked"
            />
        </div>
        <Prev-Next
                :next-disabled="nextDisabled"
                :prev-disabled="prevDisabled"
                :next-label="nextLabel"
                :prev-label="prevLabel"
                @prevClicked="handlePrev"
                @nextClicked="handleNext"
        />
    </div>
</template>
<script>
    import {CURRENT, default as Step, DONE, ON_HOLD} from './Step.vue';
    import PrevNext from '../../src/components/PrevNext.vue';

    export {ON_HOLD, CURRENT, DONE};

    export default {
        name: 'Stepper',
        components: {Step, PrevNext},
        props: {
            prevDisabled: {
                type: Boolean,
                require: false,
            },
            nextDisabled: {
                type: Boolean,
                require: false,
            },
            prevLabel: {
                type: String,
                require: false,
            },
            nextLabel: {
                type: String,
                require: false,
            },
            items: {
                type: Array,
                default: () => {
                    return [
                        {
                            status: CURRENT,
                            text: 'Step 1',
                        },
                        {
                            status: ON_HOLD,
                            text: 'Step 2',
                        },
                        {
                            status: ON_HOLD,
                            text: 'Step 3',
                        },
                        {
                            status: ON_HOLD,
                            text: 'Step 4',
                        },
                    ];
                },
            },
        },

        methods: {
            getCurrentAndNext(increment) {
                let current = this.items.find(obj => obj.status === CURRENT);
                let index = this.items.indexOf(current);
                if ((index > 0 && increment < 0) || (this.items.length > index - 1 && increment > 0)) {
                    let next = this.items[index + increment];
                    return {current, next};
                }
                return current;
            },
            handleStepClicked(stepText) {
                let currentAndClicked = {
                    'current': this.items.find(obj => obj.status === CURRENT),
                    'clicked': this.items.find(obj => obj.text === stepText),
                };
                this.$emit('stepClicked', currentAndClicked);
            },
            handlePrev() {
                this.$emit('prevClicked', this.getCurrentAndNext(-1));
            },
            handleNext() {
                this.$emit('nextClicked', this.getCurrentAndNext(+1));
            },
        },

        data() {
            return {
                ON_HOLD,
                CURRENT,
                DONE,
            };
        },
    };
</script>
<style
        lang="scss"
        scoped
>
    @import '~bootstrap/scss/functions';
    @import "../scss/_variables.scss";

    .row.stepper-row {
        // width: $step-tracker-width;
        margin-bottom: $step-tracker-margin-bottom;
    }

    @media (max-width: $step-tracker-small-screen-media-max-width) {

        .row.stepper-row {
            flex-direction: column;
            padding-right:  $step-tracker-small-screen-padding-right;
        }

    }
</style>
